import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('reports-funnels', storeModule.createStoreModule('reports-productivity'))
